import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonConfirm: React.FC<MprcButtonProps> = ({ text, title, children, color = "success", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonConfirm.text;
    const lTitle = title || theme.buttons.ButtonConfirm.title;

    return (
        <MprcButton {...rest} title={lTitle} text={lText} color={color}>{children}</MprcButton>
    );
};
